/**
 * Attach directive data.
 * @param {HTMLElement} el
 * @param {string} name
 * @param {*} data
 */
export function setDirectiveData(el, name, data) {
  if (!el._directives) {
    el._directives = {};
  }

  if (!el._directives[name]) {
    el._directives[name] = data;
  }
}

/**
 * Get data attached to the element by a directive.
 * This can retrieve only custom directive data.
 * @param {HTMLElement} el
 * @param {string} name
 * @returns {Object.<string, *>}
 */
export function getDirectiveData(el, name) {
  if (!el._directives) {
    return {};
  }

  if (!el._directives.hasOwnProperty(name)) {
    return {};
  }

  return el._directives[name];
}

/**
 * Remove data from element.
 * @param {HTMLElement} el
 * @param {string} name
 */
export function removeDirectiveData(el, name) {
  if (!el._directives) {
    return;
  }

  if (!el._directives.hasOwnProperty(name)) {
    return;
  }

  delete el._directives[name];
}

/**
 * Clone route.
 * @param {Route} route
 * @return {{name, params, query}}
 */
export function cloneRoute(route) {
  return {
    name: route.name,
    params: route.params,
    query: route.query,
  };
}
